var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnabled)?_c('v-btn',{staticClass:"quick-login-btn",attrs:{"elevation":"0","width":"120","color":"error","block":"","dark":""},on:{"click":_vm.quickLogIn}},[_vm._t("default",function(){return [_vm._v("quick login")]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }